import { createPinia } from 'pinia'
import { rootState } from './hydrate.js'

const pinia = createPinia()

pinia.state.value = rootState
export default pinia
